import { facilityQueryKeys } from "@gymflow/api";
import { FacilityDTO } from "@gymflow/types";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { numberPagination } from "libs/helpers/src/lib/pagination/numberPagination";

import useGymflowModels from "../../../../../store";
import { FormSelectInput, FormSelectInputProps } from "../FormSelectInput";

type FormSelectFacilityProps<T> = Omit<
  FormSelectInputProps<T, FacilityDTO>,
  "dataFetchingQuery"
>;

export const FormSelectFacility = <T,>({
  ...props
}: FormSelectFacilityProps<T>) => {
  const { api } = useGymflowModels();
  return (
    <FormSelectInput
      {...props}
      withImageByDefault
      dataFetchingQuery={() =>
        infiniteQueryOptions({
          queryKey: facilityQueryKeys.list(),
          queryFn: async ({ pageParam }) =>
            (
              await api.facilityApi.find({
                extraParams: { activeUser: true },
                page: pageParam,
              })
            ).data,
          select: (data) => ({
            pageParams: data.pageParams,
            pages: data.pages.map((page) =>
              page.content.map((facility) => ({
                id: facility.id,
                label: facility.name,
                value: facility,
                imageUrl: facility.picture,
              })),
            ),
          }),
          ...numberPagination,
        })
      }
    />
  );
};
